import { render, staticRenderFns } from "./page-notice.vue?vue&type=template&id=6ff5406e&scoped=true"
import script from "./page-notice.vue?vue&type=script&lang=js"
export * from "./page-notice.vue?vue&type=script&lang=js"
import style0 from "./page-notice.vue?vue&type=style&index=0&id=6ff5406e&prod&scoped=true&lang=scss"
import style1 from "./page-notice.vue?vue&type=style&index=1&id=6ff5406e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff5406e",
  null
  
)

export default component.exports